// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_5a-0";